import "./message-box.component.scss";

import { memo } from "react";
import { useTranslation } from 'react-i18next';

import { Alert } from 'react-bootstrap';

const MessageBox = props => {
  const {
    label,
    variant,
    onClose,
    ...other
  } = props;
  const { t } = useTranslation();

  return (
    <Alert
      show={!!label}
      variant={variant}
      dismissible
      onClose={onClose}
      {...other}
    >
      {t(label)}
    </Alert>
  );
};

export default memo(MessageBox);
